<template>
    <tbody>
    <tr>
        <td><i class="fas fa-grip-vertical"></i></td>
        <td>
            <p class="form-control" style="width: 142px; height: 42px;" v-if="lineitem && lineitem.goodsSerivces">{{lineitem.goodsSerivces.name}}
                <span v-if="lineitem.goodsSerivces.code">({{lineitem.goodsSerivces.code}})</span> - {{lineitem.goodsSerivces.variety}}
            </p>
        </td>
        <td>
            <input :id="'code'+index"
                   :name="'code'+index"
                   :readonly="lineitem.others"
                   class="form-control"
                   data-vv-as="code"
                   placeholder="code"
                   style="height: 42px;"
                   type="text"
                   v-model="lineitem.code">
        </td>
        <td>
            <div v-show="lineitem.others">
                <input :value="lineitem.unit.symbol" class="form-control" readonly style="height: 42px" type="text">
            </div>
            <div v-show="!lineitem.others">
                <div :class="{'is-invalid': submitted && errors.has('unit'+index)}" class="form-control p-0-0">
                    <unit-select :class="{'is-invalid': submitted && errors.has('unit'+index)}"
                                 :id="'unit'+index"
                                 :name="'unit'+index"
                                 @unit-select="setUnit"
                                 class="form-control"
                                 data-vv-as="unit"
                                 ref="reference"
                                 style="width: 142px;"
                                 v-model="lineitem.unit"
                                 v-validate="'required'">
                    </unit-select>
                </div>
                <div class="invalid-feedback" v-if="submitted && errors.has('unit'+index)">{{ errors.first('unit'+index)
                    }}
                </div>
            </div>
        </td>
        <td>
            <div class="input-group">
                <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                       :id="'quantity'+index"
                       :name="'quantity'+index"
                       :readonly="lineitem.others"
                       class="form-control"
                       data-vv-as="Quantity"
                       placeholder="Quantity"
                       style="height: 42px;"
                       type="text"
                       v-model="lineitem.quantity"
                       v-validate="'required'">
                <!--<div class="input-group-append">-->
                <!--<span class="input-group-text">{{this.units}}</span>-->
                <!--</div>-->
                <div class="invalid-feedback" v-if="submitted && errors.has('quantity'+index)">{{
                    errors.first('quantity'+index) }}
                </div>
            </div>
        </td>
        <td>
            <input :class="{'is-invalid': submitted && errors.has('rate'+index)}"
                   :id="'rate'+index"
                   :name="'rate'+index"
                   class="form-control amount"
                   data-vv-as="Rate"
                   placeholder="Rate"
                   style="height: 42px;"
                   type="text"
                   v-model="lineitem.rate"
                   v-validate="'required'">
            <div class="invalid-feedback" v-if="submitted && errors.has('rate'+index)">{{ errors.first('rate'+index)
                }}
            </div>
        </td>
        <td class="text-right">
            <span class="m-b-0" v-if="amount">{{currency.symbol}} {{amount}}</span>
        </td>
        <td class="icon-col">
            <a @click.prevent="removeItem(index)" href="#">
                <i class="far fa-trash-alt text-orange"></i>
            </a>
        </td>
    </tr>

    <tr v-for="(a, aindex) in lineitem.reductions">
        <td class="tax" colspan="5">
            {{a.type}}
        </td>
        <td>
            <div class="input-group">
                <div class="input-group-prepend">
                    <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline-secondary dropdown-toggle"
                            data-toggle="dropdown" type="button">
                        <i class="fa fa-tags" v-if="a.type === 'Discount'"></i>
                        <i class="fa fa-sliders-h" v-if="a.type === 'Adjustment'"></i>
                    </button>
                    <div class="dropdown-menu">
                        <a @click.prevent="a.type = 'Discount'" class="dropdown-item" href="#" title="Discount">
                            <i class="fa fa-tags"></i> Discount
                        </a>
                        <a @click.prevent="a.type = 'Adjustment'" class="dropdown-item" href="#" title="Adjustment">
                            <i class="fa fa-sliders-h"></i> Adjustment
                        </a>
                    </div>
                </div>
                <input :class="{'is-invalid': submitted && errors.has(index+'reduction'+aindex)}"
                       :id="index+'reduction'+aindex"
                       :name="index+'reduction'+aindex"
                       class="form-control amount"
                       data-vv-as="Reduction"
                       placeholder=""
                       type="text"
                       v-model="a.amount"
                       v-validate="'required|decimal:2|min_value:0'">
                <div class="invalid-feedback" v-if="submitted && errors.has(index+'reduction'+aindex)">{{
                    errors.first(index+'reduction'+aindex) }}
                </div>
            </div>
        </td>
        <td class="text-right">
            <span class="m-b-0 text-orange">{{currency.symbol}} {{formatReduction(a.amount)}}</span>
        </td>
        <td class="icon-col">
            <a @click.prevent="removeAdjustment(index)" href="#">
                <i class="far fa-trash-alt text-orange"></i>
            </a>
        </td>
    </tr>

    <!-- Taxes-->

    <tr v-for="(t, tindex) in lineitem.taxes">
        <td class="tax" colspan="5">
            Tax
        </td>
        <td>
            <multiselect
                    :allow-empty="false"
                    :id="index+'tax'+tindex"
                    :max-height="300"
                    :options="taxTypes"
                    :options-limit="300"
                    :searchable="true"
                    class="form-control"
                    deselect-label="Can't remove this value"
                    label="name"
                    open-direction="bottom"
                    placeholder="Select Tax"
                    style="width: 155px;"
                    track-by="rateid"
                    v-model="t.tax">
                <template slot="singleLabel" slot-scope="props">
                    <span class="option__desc">
                        <span class="option__title">{{ props.option.name }} &nbsp;&nbsp; {{ props.option.rate | unitFix(3) }}%</span>
                    </span>
                </template>
                <template slot="option" slot-scope="props">
                    <span class="option__title"><b>{{ props.option.name }}</b> &nbsp;&nbsp; {{ props.option.rate }}%</span>
                </template>
            </multiselect>
        </td>
        <td class="text-right">
            {{calculateTax(t.tax)}}
        </td>
        <td class="icon-col">
            <a @click.prevent="removeTax(index)" href="#">
                <i class="far fa-trash-alt text-orange"></i>
            </a>
        </td>
    </tr>

    <tr>
        <td class="text-right" colspan="6">
            <div class="button-group">
                <button @click="addTax()" class="btn waves-effect waves-light btn-secondary" type="button"><i
                        class="fas fa-percent"></i> Add Tax
                </button>
                <button @click="addAdjustment()" class="btn waves-effect waves-light btn-secondary" type="button"
                        v-if="!reduction"><i class="fas fa-tag"></i> Add Discount
                </button>
            </div>
        </td>
        <td colspan="2">
        </td>
    </tr>
    </tbody>
</template>

<script>
    import _ from 'lodash';
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';
    import {BigNumber} from "bignumber.js";
    import GoodsServicesSelect from "../../../protected/common/GoodsServicesSelect";
    import UnitSelect from "../../../protected/common/UnitSelect";

    export default {
        name: "InvoiceLineItem",
        props: {
            lineitem: Object,
            currency: Object,
            index: Number,
            marketplaceid: Number,
            events: Object,
            orgTaxes: Array
        },
        components: {Multiselect, GoodsServicesSelect, UnitSelect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"]),

            amount: function () {
                let amount = new BigNumber(this.lineitem.quantity).multipliedBy(new BigNumber(this.lineitem.rate));
                return amount.isNaN() ? "" : amount.toFormat(2);
            },

            units: function () {
                return this.lineitem.goodsSerivces ? this.lineitem.goodsSerivces.unit_symbol : "";
            }
        },
        data() {
            return {
                submitted: false,
                isLoading: false,
                services: [],
                taxTypes: [],
                selectedGS: null,
                reduction: false,
            };
        },
        created() {
            this.events.$on('invoicelineitem:validate', () => {
                this.validate();
            });
        },
        mounted() {
            this.init();
        },
        methods: {
            async getGoodsServices(searchText) {
                this.isLoading = true;
                let reply = await this.$http.get("/marketplaces/" + this.marketplaceid + "/commodities/search", {
                    params: {
                        search: searchText,
                        excludeOld: true
                    }
                });
                this.services = reply.data;
                this.isLoading = false;
            },

            /** Initialize **/
            async init() {
                await this.getTaxTypes();
                await this.autoFill();
            },
            async autoFill() {
                if (this.lineitem.goods_services_id) {
                    this.selectedGS = {
                        commodity_name: this.lineitem.name,
                        code: this.lineitem.code,
                        variety: this.lineitem.variety,
                        id: this.lineitem.goods_services_id,
                        commodity_id: this.lineitem.goods_services_id,
                        unit: this.lineitem.unit,
                        quantity: this.lineitem.quantity ? this.lineitem.quantity.amount : null,
                        rate: this.lineitem.rate,
                    };
                    this.lineitem.goodsSerivces = this.selectedGS;
                }

                if (this.lineitem.quantity) {
                    this.$refs.reference.unit = {
                        "id": this.lineitem.quantity.unitId,
                        "name": this.lineitem.quantity.unitName,
                        "symbol": this.lineitem.quantity.unitSymbol,
                    };
                    this.lineitem.unit = this.$refs.reference.unit;
                    this.lineitem.quantity = this.lineitem.quantity.amount;
                }

                if (this.lineitem.unit) {
                    this.$refs.reference.unit = {
                        "id": this.lineitem.unit.id,
                        "name": this.lineitem.unit.name,
                        "symbol": this.lineitem.unit.symbol,
                    };
                    this.lineitem.unit = this.$refs.reference.unit;
                }

                let mappedReduction = this.lineitem.reductions.map(r => ({
                    ...r,
                    amount: r.amount.amount
                }));
                this.lineitem.reductions = mappedReduction;

                let mappedTax = this.lineitem.taxes.map(t => ({
                    ...t,
                    tax: {
                        amount: "-",
                        description: t.description,
                        name: t.name,
                        rate: t.rate,
                        rateid: t.rateid
                    }
                }));
                this.lineitem.taxes = mappedTax;
            },

            //
            // Goods and services
            //

            setGoodsSerivces(gs) {
                if (gs && gs.name !== 'OTHERS') {
                    this.$refs.reference.unit = {
                        "id": gs.unit_id,
                        "name": gs.unit_name,
                        "symbol": gs.unit_symbol,
                    };
                    this.lineitem.unit = this.$refs.reference.unit;
                    this.lineitem.goodsSerivces = gs;
                    this.lineitem.others = false;
                } else {
                    this.$refs.reference.unit = {
                        "id": gs.unit_id,
                        "name": gs.unit_name,
                        "symbol": gs.unit_symbol,
                    };
                    this.lineitem.unit = this.$refs.reference.unit;
                    this.lineitem.goodsSerivces = gs;
                    this.lineitem.others = true;
                    this.lineitem.code = '‎';
                    this.lineitem.quantity = 1;
                }
            },
            removeItem(index) {
                this.events.$emit('invoice:removeitem', index);
            },

            //
            // Unit
            //
            setUnit(e) {
                this.lineitem.unit = e;
            },
            //
            // Taxes
            //

            async getTaxTypes() {
                this.isLoading = true;

                // let reply  = await this.$http.get(`org/${this.currentOrg.id}/taxes`);
                // let groups = reply.data;
                let groups = this.orgTaxes;

                _.forEach(groups, group => {
                    _.forEach(group.rates, rate => {
                        let tax = {
                            name: group.name,
                            description: group.description,
                            rateid: rate.id,
                            rate: rate.value,
                            amount: '-'
                        };
                        this.taxTypes.push(tax);
                    });
                });

                this.isLoading = false;
            },
            addTax() {
                this.lineitem.taxes.push({
                    tax: ''
                });
            },
            removeTax(index) {
                this.lineitem.taxes.splice(index, 1);
            },
            calculateTax(tax) {
                if (!tax || !tax.rate) {
                    return "-";
                }

                let reductions = BigNumber.sum.apply(null, _.map(this.lineitem.reductions, "amount"));

                let amount = new BigNumber(this.lineitem.quantity)
                    .multipliedBy(new BigNumber(this.lineitem.rate));

                if (!reductions.isNaN()) {
                    amount = amount.minus(reductions);
                }

                if (amount.isNegative()) {
                    amount = amount.multipliedBy(-1);
                }

                amount = amount.multipliedBy(new BigNumber(tax.rate).div(100));

                if (amount.isNaN()) {
                    return "-";
                }

                tax.amount = amount;
                return (this.currency.symbol || "") + " " + amount.toFormat(2);
            },


            //
            // Reduction
            //

            addAdjustment() {
                this.reduction = true;
                this.lineitem.reductions.push({
                    type: 'Discount',
                    amount: null
                });
            },
            removeAdjustment(index) {
                this.reduction = false;
                this.lineitem.reductions.splice(index, 1);
            },
            formatReduction(amount) {
                let reduction = new BigNumber(amount);
                return reduction.isNaN() ? "" : reduction.multipliedBy(-1).toFormat(2);
            },

            //
            // Form actions
            //

            validate(e) {
                this.submitted = true;
                this.$validator.validate();
            },
        }
    }
</script>

<style scoped>
    table th, .table td {
        padding: 1rem;
        vertical-align: top;
        border-top: 0;
    }

    table td {
        text-align: left;
        vertical-align: top;
    }

    table td.tax {
        text-align: right;
        vertical-align: middle;
    }

    amount {
        float: right;
        clear: both;
        direction: rtl;
    }
</style>
